import { render, staticRenderFns } from "./shops-admin-list.vue?vue&type=template&id=907336b6&scoped=true"
import script from "./shops-admin-list.vue?vue&type=script&lang=js"
export * from "./shops-admin-list.vue?vue&type=script&lang=js"
import style0 from "./shops-admin-list.vue?vue&type=style&index=0&id=907336b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907336b6",
  null
  
)

export default component.exports